import { render, staticRenderFns } from "./TiposVehiculos.vue?vue&type=template&id=2b8f907c&"
import script from "./TiposVehiculos.vue?vue&type=script&lang=js&"
export * from "./TiposVehiculos.vue?vue&type=script&lang=js&"
import style0 from "./TiposVehiculos.vue?vue&type=style&index=0&id=2b8f907c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports